module.exports = __webpack_public_path__ + "static/CVWriter_panel-a40513537aecab1a3a738d7d044baf01.png";